import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!

  return (_openBlock(), _createBlock(_component_q_card_actions, { align: "center" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_btn, {
        "no-caps": "",
        class: "btn-brand",
        onClick: _ctx.onHistoricData
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("Historic Data", -1)
        ]))]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }))
}